import React from "react"
import { RRButtonFooter } from "../atoms/roundedrectangle/RRButtonFooter"
import { Spacer } from "../atoms/Atoms"
import { RoundedRectangle } from "../atoms/roundedrectangle/RoundedRectangle"
import L10n from "../../../lib/carrot-l10n"
import { BodyLarge } from "../atoms/Bodies"
import { RetinaImage } from "../atoms/images/RetinaImage"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

/**
A module that draws attention of the user to Carrot Rx and links them to more information.
 */
export const CarrotRxModule = ({ id }) => (
  <RoundedRectangle id={id} backgroundColor="light-blue">
    <RetinaImage height={12.1} width={116} name={"carrotrx-logo"} />
    <Spacer height={1.5} />
    <BodyLarge>{l`Significant savings on fertility medications with Carrot Rx.`}</BodyLarge>
    <Spacer height={0.5} />
    <RRButtonFooter to={"/your-benefit-guide/coverage/carrot-rx"} outline>
      Learn more
    </RRButtonFooter>
  </RoundedRectangle>
)
